import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";

const useStyles = makeStyles(theme => ({
  card: {
    width: "100%",
    height: "100%"
  },

  titleIcons: {
    color: theme.palette.text.secondary
  },
  saveButton: {
    width: 120,
    marginLeft: "auto"
  },
  pre: {
    whiteSpace: "pre-line"
  }
}));

const FaqCard = ({ mobile, faq, onSave }) => {
  const classes = useStyles();
  const [edit, setEdit] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, seAnswer] = useState("");

  useEffect(() => {
    if (faq) {
      setQuestion(faq.question);
      seAnswer(faq.answer);
    } else {
      setEdit(true);
    }
  }, [faq]);

  const isValid = () => {
    return question.trim() !== "" && answer.trim() !== "";
  };

  const cancel = () => {
    if (faq) {
      setQuestion(faq.question);
      seAnswer(faq.answer);
      setEdit(false);
    } else {
      setQuestion("");
      seAnswer("");
    }
  };

  const save = () => {
    if (faq) {
      setEdit(false);
      onSave({ ...faq, question, answer });
    } else {
      onSave({ question, answer });
      setQuestion("");
      seAnswer("");
    }
  };

  return (
    <Card className={classes.card}>
      {!faq && <CardHeader title="Agregar pregunta" />}
      <CardContent>
        <Grid container spacing={2} alignItems="baseline">
          <Grid item xs={2} sm={1}>
            <LiveHelpIcon className={classes.titleIcons} />
          </Grid>
          <Grid item xs={9} sm={10}>
            {!edit ? (
              <Typography variant={mobile ? "body2" : "body1"}>{question}</Typography>
            ) : (
              <TextField
                fullWidth
                label="Pregunta"
                value={question}
                onChange={({ target }) => setQuestion(target.value)}
              />
            )}
          </Grid>
          <Grid item xs={1}>
            {!edit && (
              <IconButton onClick={() => setEdit(true)}>
                <EditIcon />
              </IconButton>
            )}
          </Grid>

          <Grid item xs={2} sm={1}>
            <QuestionAnswerIcon className={classes.titleIcons} />
          </Grid>
          <Grid item xs={9} sm={10}>
            {!edit ? (
              <Typography
                className={classes.pre}
                component="pre"
                variant={mobile ? "body2" : "body1"}
              >
                {answer}
              </Typography>
            ) : (
              <TextField
                fullWidth
                multiline
                rows={6}
                label="Respuesta"
                value={answer}
                onChange={({ target }) => seAnswer(target.value)}
              />
            )}
          </Grid>
          <Grid item xs={1} />
        </Grid>
      </CardContent>
      {edit && (
        <CardActions>
          <Button className={classes.saveButton} color="primary" onClick={cancel}>
            Cancelar
          </Button>
          <Button
            disabled={!isValid()}
            className={classes.saveButton}
            color="primary"
            onClick={save}
          >
            Guardar
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

export default FaqCard;
